<template>
  <div>
    <div class="onehalf first">
      <ul>
        <draggable
          class="list-group"
          :list="listOneItems"
          :sort="false"
          :id="'q_' + answersKey"
          :group="answersKey"
        >
          <li
            class="list-group-item li"
            v-for="(e, index) in listOneItems"
            :data="e"
            :key="'q_' + e.value + index"
          >
            {{ e.text }}
          </li>
        </draggable>
      </ul>
    </div>
    <!-- this.$store.state.answers[q.variable] -->
    <div class="onehalf second">
      <ul>
        <draggable
          class="list-group"
          :id="'a_' + answersKey"
          :list="sortedList"
          :sort="true"
          :group="answersKey"
          @change="
            (e) => {
              e;
            }
          "
          draggable=".list-group-item"
        >
          <li
            class="list-group-item li"
            v-for="(e, index) in sortedList"
            :data="e"
            :key="'a_' + e.value + index"
          >
            {{ e.text }}
          </li>
        </draggable>
      </ul>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

const props = {
  name: "two-list",
  listOneItems: {
    required: true,
    type: Array,
    default: null,
  },
  answersKey: {
    required: true,
    type: String,
    default: null,
  },
};
export default {
  data() {
    return {
      sortedList: [],
    };
  },
  components: {
    draggable,
  },
  props,
  mounted() {
    try {
      let answer = this.$store.state.answers[this.answersKey];
      if(typeof answer == "string") answer = JSON.parse(answer);
      this.sortedList = answer;
    }
    catch(e) {
      this.sortedList = [];
    }
  },
  watch: {
    sortedList(Val) {
      this.$store.dispatch("updateOrderAnswers", {
        key: this.answersKey,
        value: Val,
      });
    },
  },
  methods: {},
};
</script>

<style scoped>
/*
ul li {
  line-height: 24px;
}
/** */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(50px);
  opacity: 0;
}

.list-group {
  height: 150px;
}
/*
.radio-label {
  margin-bottom: 8px;
  width: 220px;
}
.radio-label-2 {
  margin-bottom: 8px;
  width: 250px;
}
/** */
</style>
